export enum StaffMemberDetailsTabId {
	CoreData = "core-data",
	EmploymentDetails = "employment-details",
	Compensation= "compensation",
	Documents = "documents",
	WorkingSchedules = "working-schedules",
}